<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/ex/list">展商管理</BreadcrumbItem>
          <BreadcrumbItem>查看展商</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">查看展商</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/host/index/ex/list')">返回</Button>
      </div>
    </div>
    <div class="layout-content">
      <!-- .company-info-basic .cib -->
      <div class="cib">
        <Row>
          <Col span="12">
          <div class="cib-l">
            <div class="cib-form">
              <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="120" @submit.native.prevent>
                <FormItem label="公司全称：" prop="CompName">
                  <Input type="text" v-model="formInline.CompName" disabled />
                </FormItem>
                <FormItem label="公司简称：" prop="ShortName">
                  <Input type="text" v-model="formInline.ShortName" disabled />
                </FormItem>
                <FormItem label="公司英文名：" prop="CompNameEn">
                  <Input type="text" v-model="formInline.CompNameEn" disabled />
                </FormItem>
                <!-- <FormItem label="展品类别：" prop="type" :required="true">
                  <categoryFiled v-model="formInline.type" ref="categoryFiled" :open="true"></categoryFiled>
                </FormItem> -->

                <FormItem label="展品类别：" prop="category" :required="true" v-if="type">
                  <Cascader :disabled="true" change-on-select v-model="formInline.category" :data="type" filterable></Cascader>
                </FormItem>

                <Row v-for="(booth, index) in formInline.boothInfo" :key="'boothInfo-' + index">
                  <Col span="12">
                  <FormItem label="展馆编号：">
                    <Input v-model="booth.Hall" disabled />
                    <!-- <Select v-model="booth.Hall" disabled filterable>
                          <Option
                            v-for="item in exHallArr"
                            :value="item.name"
                            :key="item.name"
                          >{{ item.name }}</Option>
                        </Select> -->
                  </FormItem>
                  </Col>
                  <Col span="12">
                  <FormItem label="展位编号：" prop="time">
                    <Input v-model="booth.Code" disabled />
                  </FormItem>
                  </Col>
                  <!-- <Col span="2" class="ie-icon">
                      <Icon type="ios-add-circle-outline" v-if="index === 0" @click="addBootArr()" />
                      <Icon
                        type="ios-remove-circle-outline"
                        v-else
                        style="color: red;"
                        @click="delBootArr(index)"
                      />
                    </Col> -->
                </Row>

                <FormItem label="所在省市：" style="margin-bottom: 0;">
                  <Row type="flex" justify="space-between">
                    <Col span="11">
                    <FormItem prop="province">
                      <!-- <Select
                            v-model="formInline.Province"
                            @on-change="changeProvince"
                            disabled
                          >
                            <Option
                              v-for="(item, index) in provinceArr"
                              :key="item.value"
                              :value="item.value"
                            >{{ item.label }}</Option>
                          </Select> -->
                      <Input v-model="formInline.Province" disabled />
                    </FormItem>
                    </Col>
                    <Col span="11">
                    <FormItem prop="city">
                      <!-- <Select
                            v-model="formInline.City"
                            @on-change="changeCity"
                            disabled
                          >
                            <Option
                              v-for="(item, index) in citiesArr"
                              :key="item.value"
                              :value="item.value"
                            >{{ item.label }}</Option>
                          </Select> -->
                      <Input v-model="formInline.City" disabled />
                    </FormItem>
                    </Col>
                  </Row>
                </FormItem>
                <!-- <FormItem>
                    <Button
                      type="primary"
                      size="large"
                      @click="mySubmit('formInline')"
                      style="width: 154px;"
                    >保存</Button>
                  </FormItem> -->
              </Form>
            </div>
          </div>
          </Col>
          <Col span="12">
          <div class="cib-r">
            <Form label-position="right" :label-width="120" @submit.native.prevent>
              <FormItem label="公司logo：">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index" style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;">
                      <template v-if="item.status === 'finished'">
                        <img :src="item.url" style="width: 150px;height: 150px;" v-if="item.url" />
                        <template v-else>
                          <img src="@assets/img/company-default-logo.png" style="width: 150px;height: 150px;" />
                        </template>
                        <div class="my-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        </div>
                      </template>
                      <template v-else>
                        <Spin v-if="item.showProgress" style="width: 150px;height: 150px;">
                          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div class="my-upload-list" style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;" v-else>
                    <template>
                      <!-- <img
                          src="@assets/img/company-default-logo.png"
                          style="width: 150px;height: 150px;"
                        /> -->
                    </template>
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <div v-else style="width:40px;height:40px;border:1px solid #bfbfbf;"></div>
                      <!-- <img src="@assets/img/company-default-logo.png" v-else /> -->
                      <p>预览尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <div v-else style="width:30px;height:30px;border:1px solid #bfbfbf;"></div>
                      <!-- <img src="@assets/img/company-default-logo.png" v-else /> -->
                      <p>预览尺寸：120*120px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <div v-else style="width:20px;height:20px;border:1px solid #bfbfbf;"></div>
                      <!-- <img src="@assets/img/company-default-logo.png" v-else /> -->
                      <p>预览尺寸：30*30px</p>
                    </div>
                  </div>
                </div>
                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg','jpeg','png']" :max-size="2048" :headers="formHeaders" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :action="uploadUrl" style="display: inline-block;position: relative;" v-if="false">
                  <Button icon="ios-cloud-upload-outline">更改Logo</Button>
                  <div style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"></div>
                </Upload>
                <!-- <p class="upload-p">(图片要求：2M以下的jpg或png，建议尺寸120*120px)</p> -->
              </FormItem>
            </Form>
          </div>
          </Col>
        </Row>
        <!-- 图片查看 -->
        <iModal title="图片查看" cancel-text v-model="visible">
          <div style="text-align: center;">
            <img :src="imgName" v-if="visible" style="max-width: 100%" />
          </div>
        </iModal>
      </div>
    </div>
  </div>
</template>

<script>
import { provinces } from "@/other/provinces";
import { mapGetters, mapActions } from "vuex";
import categoryFiled from "@components/category-filed/category-filed.vue";

export default {
  name: "ex-edit",
  data () {
    return {

      type: [],
      loading: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      commonType: 2,
      Introduction: [],
      provinceArr: [],
      citiesArr: [],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      formInline: {
        // form双向绑定
        CompName: "", // 公司名
        CompNameEn: "", // 公司英文名
        ShortName: "", // 简称
        Country: "",
        Province: "",
        City: "",
        category: [], // 展品分类

        type: [], // 展品类别
        boothInfo: [{ Hall: "", Code: "" }]
      },

      exHallArr: [],
      exTypeArr: [], // 展商类别
      ruleInline: {
        // 效验规则
        CompName: [
          { required: true, message: "公司全称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 3,
            message: "公司全称不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "公司全称不能大于50位",
            trigger: "blur"
          }
        ],
        ShortName: [
          { required: true, message: "公司简称不能为空", trigger: "blur" }
        ],
        Province: [
          {
            required: true,
            message: "请选择所在的省份",
            trigger: "change"
          }
        ],
        City: [
          { required: true, message: "请选择所在的城市", trigger: "change" }
        ],
        type: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("展品类别为必填选项");
              } else if (value.length) {
                callback();
              } else {
                callback("展品类别为必填选项");
              }
            },
            trigger: "blur"
          }
        ]
      },
      visible: false,
      defaultList: [],

      uploadList: [],

      coverImg: "",
      uploadVideoFlag: false,
      AgentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43",

      editId: "",
      list: null
    };
  },
  components: {
    categoryFiled
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    }),
    option () {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "compId",
                  Value: `%${this.editId}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created () {
    let query = this.$route.query;
    if (query && query.id) {
      this.editId = query.id;
    }
    this.provinceArr = provinces.data;
    this.init();
  },
  methods: {
    ...mapActions({
      getCompanyByJoin: "hostSetModule/getCompanyByJoin",
      editCompany: "companyModule/editCompany",

      getHallByExhibition: "exhibitionModule/getHallByExhibition",
      getCategoryByExhibition: "exhibitionModule/getCategoryByExhibition",
      getCategoryByExhibitionList:
        "exhibitionModule/getCategoryByExhibitionList",

      getProductByGroupId: "categoryModule/getProductByGroupId", // 根据展会Id获取产品类别

      RegisterAccount: "hostSetModule/RegisterAccount", // 添加用户
      RegisterCompany: "hostSetModule/RegisterCompany", // 添加公司
      RegisterJoin: "hostSetModule/RegisterJoin", // 添加参展
      RegisterStaff: "hostSetModule/RegisterStaff" // 添加员工
    }),
    async init () {
      // let hallData = await this.getHallByExhibition(this.exhibitionInfo.id);
      // if (hallData && hallData.length) {
      //   this.exHallArr = hallData;
      // } else {
      //   this.exHallArr = [];
      // }

      let proData = await this.getCompanyByJoin(this.option);
      if (proData) {
        proData.items.map(c => {
          if (c.categories) {
            c.categories = JSON.parse(c.categories);
          } else {
            c.categories = [];
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo);
          } else {
            c.boothInfo = [];
          }
        });
        this.list = proData.items[0];
      }
      if (this.list) {
        if (this.list.logo) {
          this.defaultList = [
            {
              name: this.list.name,
              url: this.list.logo,
              status: "finished",
              percentage: 100
            }
          ];
          this.uploadList = this.defaultList;
        }
        if (this.list.name) {
          this.formInline.CompName = this.list.name || "";
        }
        if (this.list.country) {
          this.formInline.Country = this.list.country || "中国";
        }
        if (this.list.province) {
          this.changeProvince(this.list.province);
          this.formInline.Province = this.list.province || "";
        }
        if (this.list.city) {
          this.changeCity(this.list.city);
          this.formInline.City = this.list.city || "";
        }
        if (this.list.shortName) {
          this.formInline.ShortName = this.list.shortName || "";
        }
        if (this.list.nameEn) {
          this.formInline.CompNameEn = this.list.nameEn || "";
        }
        if (this.list.boothInfo) {
          let boothInfo = this.list.boothInfo;
          if (boothInfo.indexOf("[") !== -1) {
            boothInfo = JSON.parse(boothInfo);
          }
          if (this.list.boothInfo.length && Object.prototype.toString.call(boothInfo) === '[object Object]') {
            this.formInline.boothInfo = [{ Hall: boothInfo.Hall, Code: boothInfo.Code }];
          }
          if (this.list.boothInfo.length && Object.prototype.toString.call(boothInfo) === '[object Array]') {
            this.formInline.boothInfo = [{ Hall: boothInfo[0].Hall, Code: boothInfo[0].Code }];
          }
          // this.formInline.boothInfo =
          //   boothInfo && boothInfo.indexOf("[") !== -1
          //     ? JSON.parse(boothInfo)
          //     : [{ Hall: "", Code: "" }];
        } 
        if (this.list.categories && this.list.categories[0]) { 
          const category = this.list.categories[0];
          const categoryArr = [];
          if (category.Name) {
            categoryArr.push(category.Name);
            if (category.List[0]) {
              categoryArr.push(category.List[0].Name);
              if (category.List[0].List) {
                categoryArr.push(category.List[0].List[0].Name);
              }
            }
          }
          this.formInline.category = categoryArr; 
        }
      }

      let categoryData = await this.getProductByGroupId({
        groupId: this.exhibitionInfo.groupId,
        level: 0,
        loadChild: true,
      }); // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map((c) => {
          // c.value = c.id;
          c.value = c.name;
          c.label = c.name;
          c.children = JSON.parse(JSON.stringify(c.list));
          c.children.map((v) => {
            // v.value = v.id;
            v.value = v.name;
            v.label = v.name;
            v.children = JSON.parse(JSON.stringify(v.list));
            v.children.map((z) => {
              z.value = z.id;
              z.value = z.name;
              z.label = z.name;
              z.children = JSON.parse(JSON.stringify(z.list));
            });
          });
        });
        this.type = categoryData;
      } else {
        this.type = [];
      }
    },
    async mySubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let logo = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      }
      let companyReq = {
        // 公司请求opt 
        Id: this.list.compId,
        SetValues: {
          Logo: logo,
          Name: form.CompName,
          ShortName: form.ShortName,
          CompNameEn: form.CompNameEn,
          Province: form.Province,
          City: form.City,
          Categories: JSON.stringify(form.type),
          BoothInfo: JSON.stringify(form.boothInfo),
        }
      };
      console.log("companyReq: ", companyReq);
      let company = null;
      let data2 = await this.editCompany(companyReq); // 注册公司
      if (data2 && data2.info) {
        company = data2.info;
      } else {
        this.$Message.error(data2.errors[0].description);
        return;
      }
      this.$Message.success("保存成功!");
      setTimeout(() => {
        this.$router.push("/host/index/ex/list");
      }, 400);
    },

    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片"
      });
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片"
      });
    },
    handleBeforeUpload () {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      return check;
    },
    changeProvince (val) {
      this.formInline.City = this.list.city || "";
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.citiesArr = this.provinceArr[i].children;
          this.countyArr = [];
        }
      }
    },
    changeCity (val) {
      for (var i = 0; i < this.citiesArr.length; i++) {
        if (val == this.citiesArr[i].value) {
          this.countyArr = this.citiesArr[i].children;
        }
      }
    },
    selectChange (e) {
      if (e && e.length > 3) {
        this.formInline.type = [e[0], e[1], e[2]];
      }
    },
    addBootArr () {
      this.formInline.boothInfo.push({ Hall: "", Code: "" });
    },
    delBootArr (i) {
      this.formInline.boothInfo.splice(i, 1);
    },
    changeCategory (val) {
      let category = this.form.category;
      if (val) {
        category = this.form.category = val;
      }
      console.log('category', category);
      console.log('type', this.type);
      let data = null;
      this.type.forEach((c) => {
        if (category[0] && c.name === category[0]) {
          data = JSON.parse(JSON.stringify(c));
          data.list = [];
          delete data.children;
          if (c.list && c.list.length && category[1]) {
            c.list.forEach((v) => {
              if (v.name === category[1]) {
                data.list[0] = JSON.parse(JSON.stringify(v));
                data.list[0].list = [];
                delete data.list[0].children;
                if (v.list && v.list.length && category[2]) {
                  v.list.forEach((j) => {
                    if (j.name === category[2]) {
                      data.list[0].list[0] = JSON.parse(JSON.stringify(j));
                      delete data.list[0].list[0].children;
                    }
                  });
                }
              }
            });
          }
        }
      });
      console.log('changeCategory', data);
      return data ? [data] : [];
    },
  }
};
</script>

<style scoped lang="scss">
.ie-icon {
  line-height: 31px;
  padding-left: 30px;
  .ivu-icon {
    font-size: 22px;
    cursor: pointer;
    font-size: 22px;
    color: #118eea;
  }
  &.z-remove {
    color: #d71f06;
  }
}
.addcase {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 900px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
</style>
